<template>
  <div>
    <!--<div class="operate">-->
    <!--<el-button-->
    <!--plain-->
    <!--size="mini"-->
    <!--type="single-number"-->
    <!--class="ml10 table-top-right"-->
    <!--@click="refreshHeimingdan"-->
    <!--&gt;查看供应商历史综合评价信息</el-button-->
    <!--&gt;-->
    <!--</div>-->
    <el-button
      plain
      size="mini"
      type="single-number"
      class="ml10"
      style="margin-right:100px;float:right"
      @click="refreshXinxi"
      >刷新</el-button
    >
    <el-button
      plain
      size="mini"
      type="single-number"
      class="ml10"
      style="margin-right:20px;float:right"
      :disabled="isClicked"
      :title="isClicked ? '评分获取中，请稍后' : ''"
      @click="refreshScore"
      >更新评分</el-button
    >
    <el-table
      :data="tableData"
      style="width: 100%;margin-top:20px"
      row-key="id"
      border
      class="report multifunctional-table dic-sub-table-style01"
    >
      <el-table-column type="index" label="序号" width="51" align="left" />
      <el-table-column
        prop="supName"
        label="供应商名称"
        width="220"
        :show-overflow-tooltip="true"
      />
      <el-table-column prop="scoreStr" label="供应商采购风险评分" width="130" />
      <el-table-column prop="riskLevel" label="风险等级" width="100">
        <template slot-scope="scope">
          <span :style="'color:' + riskLevelColor(scope.row.riskLevel)">
            {{
              scope.row.riskLevel == 1
                ? "高风险"
                : scope.row.riskLevel == 2
                ? "较高风险"
                : scope.row.riskLevel == 3
                ? "中风险"
                : scope.row.riskLevel == 4
                ? "较低风险"
                : scope.row.riskLevel == 5
                ? "低风险"
                : ""
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="reportUrl" label="报告链接" width="190">
        <template slot-scope="scope">
          <span
            class="heighlight"
            @click="handleView(scope.row)"
            style="width:100%;display: inline-block;white-space: nowrap;overflow: hidden;line-height:1;text-overflow: ellipsis;"
          >
            {{ scope.row.reportUrl }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="endTime"
        label="报告生成时间"
        width="150"
        :show-overflow-tooltip="true"
      />
    </el-table>
    <!--   分页功能  -->
    <!--<div class="table-footer" style="height:30px">-->
    <!--<div class="ccui-table-footer">-->
    <!--<div id="ccui-paging">-->
    <!--<el-pagination-->
    <!--:total="total"-->
    <!--:page-size="pageSize"-->
    <!--:current-page="pageNo"-->
    <!--prev-text="< 上一页"-->
    <!--next-text="下一页 >"-->
    <!--background-->
    <!--layout="total, sizes, prev, pager, next, jumper"-->
    <!--popper-class="ccui-paging-page-size-popper"-->
    <!--@prev-click="handlePrev"-->
    <!--@next-click="handleNext"-->
    <!--@size-change="handleSizeChange"-->
    <!--@current-change="handleCurrentChange"-->
    <!--/>-->
    <!--<el-button-->
    <!--class="ccui-pagination-btn"-->
    <!--size="mini"-->
    <!--type="default"-->
    <!--@click="handleGoPage('none')"-->
    <!--&gt;确定</el-button-->
    <!--&gt;-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <el-dialog :visible.sync="dialogVisible" width="1000px" height="70vh">
      <iframe
        :src="reportUrl"
        frameborder="0"
        height="100%"
        width="100%"
      ></iframe>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="dialogVisible = false"
          >关闭</el-button
        >
        <!--<el-button size="mini" type="primary-font-mini" @click="addRoleInfo()"-->
        <!--&gt;提交</el-button-->
        <!--&gt;-->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  queryPurchaseRiskScoreList,
  dealPurchaseRiskScore,
  download
} from "@/app/sourcingFlow/api/expertEvaluation.js";
export default {
  name: "supCredit-table",
  data() {
    return {
      total: 1,
      pageNo: 1,
      dialogVisible: false,
      reportUrl: "",
      pageSize: 10,
      clientHeight: 0,
      isClicked: false,
      tableHeight: 0,
      labelPosition: "right",
      isShow: false,
      input: "",
      value: "",
      tableData: []
    };
  },
  props: {
    schemeId: {
      type: String,
      default: ""
    }
  },
  mounted() {},
  computed: {
    riskLevelColor() {
      return function(value) {
        let arr = ["", "#FF142F", "#FF7E14", "#FFCF00", "#0089EF", "#0DCA19"];
        return arr[value];
      };
    }
  },
  created() {
    // queryAccessRiskScoreList({
    //   supCode: this.$route_query.supCode,
    //   pageSize: 1,
    //   pageNo: 1
    // }).then(res => {
    //   this.tableData = res.data.data.rows;
    // });
    this.queryPurchaseRiskScoreList();
  },
  methods: {
    handleView(row) {
      download({
        reportName: row.reportUrl,
        // reportName:'上海智信专利代理有限公司_10052_866575.pdf',
        isShowLoading: true
      }).then(res => {
        this.dialogVisible = true;
        // const blob = new Blob([res.data], { type: res.data.type });
        // const url = window.URL.createObjectURL(blob);
        // this.reportUrl = url;
        this.reportUrl = res.data.data.data.address;
      });
    },
    queryPurchaseRiskScoreList() {
      console.log(this.schemeId);
      queryPurchaseRiskScoreList({
        schemeId: this.schemeId,
        pageSize: this.pageSize,
        step: "2",
        pageNo: this.pageNo
      }).then(res => {
        // this.total = res.data.data.recordsTotal;
        if (res.data.data.rows[0].scoreStr != "评价中") {
          this.isClicked = false;
        }
        this.tableData = res.data.data.rows;
      });
    },
    refreshScore() {
      let param = {
        schemeId: this.schemeId,
        isShowLoading: true
      };
      dealPurchaseRiskScore(param).then(res => {
        this.isClicked = true;
        this.refreshXinxi();
      });
    },
    refreshXinxi() {
      this.queryPurchaseRiskScoreList();
    },
    handlePrev() {
      this.pageNo--;
      this.queryPurchaseRiskScoreList();
    },
    handleNext() {
      this.pageNo++;
      this.queryPurchaseRiskScoreList();
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.pageNo = 1;
      this.queryPurchaseRiskScoreList();
    },
    handleCurrentChange(newNum) {
      this.pageNo = newNum;
      this.queryPurchaseRiskScoreList();
    }
  }
};
</script>
<style lang="scss" scoped>
.operate {
  margin: 0 0 20px;
  float: right;
}
/deep/.el-table.report .el-table__footer-wrapper td {
  border-top: 1px solid #edf2fc !important;
}
.table-top-right {
  margin-top: 20px;
}
/deep/.el-table__empty-block {
  width: 100% !important;
}
/deep/.el-dialog__body {
  height: 70vh;
  overflow: hidden !important;
}
/deep/.el-button.is-disabled.is-plain {
  background-color: #e5e5e5;
  span {
    color: #999;
  }
}
</style>
